var _path, _path2, _g, _circle, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePasswordSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.243 106.244C112.084 132.251 78.5097 141.161 52.2532 126.146C25.9967 111.131 17.0006 77.8769 32.1598 51.8704C47.3189 25.8639 80.893 16.9535 107.149 31.9683C133.406 46.9832 142.402 80.2375 127.243 106.244Z",
    fill: "url(#paint0_linear_4916_661328)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.243 106.244C112.084 132.251 78.5097 141.161 52.2532 126.146C25.9967 111.131 17.0006 77.8769 32.1598 51.8704C47.3189 25.8639 80.893 16.9535 107.149 31.9683C133.406 46.9832 142.402 80.2375 127.243 106.244Z",
    fill: "url(#paint1_linear_4916_661328)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4916_661328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.433 97.0334H89.6333V86.5001H82.576C79.574 92.8727 73.096 97.0334 65.9333 97.0334C55.7687 97.0334 47.5 88.7647 47.5 78.6001C47.5 68.4354 55.7687 60.1667 65.9333 60.1667C73.096 60.1667 79.5477 64.3274 82.576 70.7001H110.7V86.5001H105.433V97.0334ZM94.9 91.7667H100.167V81.2334H105.433V75.9667H78.942L78.3363 74.2024C76.493 68.9621 71.4897 65.4334 65.9333 65.4334C58.6653 65.4334 52.7667 71.3321 52.7667 78.6001C52.7667 85.8681 58.6653 91.7667 65.9333 91.7667C71.4897 91.7667 76.493 88.2381 78.3363 82.9977L78.942 81.2334H94.9V91.7667ZM65.9333 86.5001C61.5883 86.5001 58.0333 82.9451 58.0333 78.6001C58.0333 74.2551 61.5883 70.7001 65.9333 70.7001C70.2783 70.7001 73.8333 74.2551 73.8333 78.6001C73.8333 82.9451 70.2783 86.5001 65.9333 86.5001ZM65.9333 75.9667C64.485 75.9667 63.3 77.1517 63.3 78.6001C63.3 80.0484 64.485 81.2334 65.9333 81.2334C67.3817 81.2334 68.5667 80.0484 68.5667 78.6001C68.5667 77.1517 67.3817 75.9667 65.9333 75.9667Z",
    fill: "#0662C4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126.4,
    cy: 116.115,
    r: 26.3333,
    fill: "url(#paint2_linear_4916_661328)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.133 123.685L113.812 116.364L111.319 118.839L121.133 128.653L142.2 107.586L139.724 105.111L121.133 123.685Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4916_661328",
    x1: 28.3382,
    y1: 113.266,
    x2: 150.214,
    y2: 63.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#669DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4916_661328",
    x1: 79.7407,
    y1: 24.6746,
    x2: 130.589,
    y2: 98.3438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4916_661328",
    x1: 126.419,
    y1: 89.7817,
    x2: 126.419,
    y2: 142.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027C06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98E492"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4916_661328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.2,
    height: 63.2,
    fill: "white",
    transform: "translate(47.5 47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordSuccess);
export default __webpack_public_path__ + "static/media/change-password-success.53c03b51ca96312b1c43b5c839331c67.svg";
export { ForwardRef as ReactComponent };